
import { useCallback } from 'react';

/**
 * Hook to handle active admin user functionality
 */
export const useAdminActiveUser = (
  removeActiveAdmin: (adminName: string) => Promise<any>,
  removeAdminService: (adminName: string) => any
) => {
  // Handle removing an active admin
  const handleRemoveActiveAdmin = useCallback(async (adminName: string) => {
    try {
      const updatedState = await removeActiveAdmin(adminName);
      return updatedState;
    } catch (error) {
      console.error('Error in removeActiveAdmin:', error);
      return removeAdminService(adminName);
    }
  }, [removeActiveAdmin, removeAdminService]);
  
  return {
    removeActiveAdmin: handleRemoveActiveAdmin
  };
};
